<template>
  <div
    class="relative z-30 text-dark-900 flex flex-col items-center justify-center pt-10 max-w-[650px] mx-auto text-center px-3 md:px-0"
  >
    <div class="space-y-3 md:space-y-5">
      <h1
        class="text-[28px] md:text-[48px] xl:text-[62px] font-bold leading-[28px] md:leading-[48px] xl:leading-[64px]"
      >
        {{ t("landing.hero.title") }}
      </h1>
      <p
        class="text-dark text-sm md:text-base"
        v-html="t('landing.hero.description')"
      ></p>
    </div>
    <div
      class="flex-y-center gap-4 flex-col sm:flex-row mt-8 md:mt-[48px] min-w-[260px]"
    >
      <a href="https://app.sarafrobot.com/" target="_blank" class="w-full">
        <BaseButton
          size="lg"
          :text="t('landing.hero.try_button')"
          class="flex-y-center justify-center w-full"
        />
      </a>
      <BaseButton
        v-if="false"
        :text="t('landing.hero.watch_demo')"
        variant="outline"
        class="w-full sm:w-auto"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";
const { t } = useI18n();
</script>

<style scoped></style>
